// extracted by mini-css-extract-plugin
export default {"cta":"QuizCta_cta__dflDA","eyebrow":"QuizCta_eyebrow__UHsmU","title":"QuizCta_title__SsFu6","subtitle":"QuizCta_subtitle__zRA4u"};